import React, { useCallback } from 'react';
import { useAppContext } from '@/context/AppContext';

export function GroupSelector() {
  const { state, dispatch } = useAppContext();

  const handleGroupTypeChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const groupType = event.target.value as 'vehGroups' | 'pedGroups';
    dispatch({ type: 'SET_GROUP_TYPE', payload: groupType });
  }, [dispatch]);

  return (
    <div className="group-select-container">
      <label htmlFor="groupType">Select Group Type: </label>
      <select 
        id="groupType"
        value={state.ui.selectedGroupType}
        onChange={handleGroupTypeChange}
        className="group-selector"
      >
        <option value="vehGroups">Vehicle Groups</option>
        <option value="pedGroups">Ped Groups</option>
      </select>
    </div>
  );
}